const NAVBAR_SELECTOR = '[data-custom-navbar]';
const THEME_STORAGE_KEY = 'custom-navbar-theme';

const getSystemTheme = () => (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

const applyTheme = (mode) => {
  const root = document.documentElement;
  const resolved = mode === 'system' ? getSystemTheme() : mode;
  root.dataset.customNavbarTheme = mode;
  root.dataset.customNavbarThemeResolved = resolved;
};

const setThemeFromStorage = () => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY) || 'system';
  applyTheme(stored);
};

const closeDropdown = (dropdown) => {
  dropdown.classList.remove('is-open');
  const toggle = dropdown.querySelector('[data-custom-navbar-toggle]');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
};

const openDropdown = (dropdown) => {
  dropdown.classList.add('is-open');
  const toggle = dropdown.querySelector('[data-custom-navbar-toggle]');
  if (toggle) toggle.setAttribute('aria-expanded', 'true');
};

const initNavbar = () => {
  const navbar = document.querySelector(NAVBAR_SELECTOR);
  if (!navbar) return;

  setThemeFromStorage();

  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  mediaQuery.addEventListener('change', () => {
    const mode = document.documentElement.dataset.customNavbarTheme || 'system';
    applyTheme(mode);
  });

  const dropdowns = Array.from(navbar.querySelectorAll('[data-custom-navbar-dropdown]'));

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector('[data-custom-navbar-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = dropdown.classList.contains('is-open');
      dropdowns.forEach(closeDropdown);

      if (!isOpen) {
        openDropdown(dropdown);
      }
    });
  });

  document.addEventListener('click', () => {
    dropdowns.forEach(closeDropdown);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      dropdowns.forEach(closeDropdown);
    }
  });

  const themeButtons = navbar.querySelectorAll('[data-custom-navbar-theme]');
  themeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const mode = button.getAttribute('data-custom-navbar-theme');
      if (!mode) return;
      localStorage.setItem(THEME_STORAGE_KEY, mode);
      applyTheme(mode);
      dropdowns.forEach(closeDropdown);
    });
  });

  const sidebarToggle = navbar.querySelector('[data-custom-navbar-sidebar-toggle]');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', () => {
      const menuToggle = document.querySelector('.header__icon--menu');
      if (menuToggle) {
        menuToggle.click();
        return;
      }
      document.documentElement.classList.toggle('custom-navbar-sidebar-open');
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNavbar);
} else {
  initNavbar();
}
